import { Box } from '@mui/material';
import React, { PureComponent } from 'react';

import { Motion } from '@sbu/components.motion';

import { Record, RecordType } from './Record';
import { type EntityTypeFieldsAndIndicator } from './useEntityTypeRecordFields';

interface RecordsProps {
  expanded: { [id: number]: boolean };
  visibleIndex: number;
  records: RecordType[];
  onExpandCollapse: (record: RecordType) => void;
  entityTypeFieldsAndIndicator?: EntityTypeFieldsAndIndicator;
}

export class Records extends PureComponent<RecordsProps> {
  render() {
    const {
      expanded,
      onExpandCollapse,
      records,
      visibleIndex,
      entityTypeFieldsAndIndicator,
    } = this.props;
    const visibleRecords = records.slice(0, visibleIndex);

    return (
      <Box display='flex'>
        <Box flex={1}>
          <Motion type='group'>
            {visibleRecords.map((record, index) => (
              // Record IDs are not guaranteed to be unique.
              <Box
                component={Motion}
                key={`record-${index}`}
                marginBottom={2}
                sx={{ willChange: 'transform, opacity' }}
                type='item'
              >
                <Record
                  entityTypeFieldsAndIndicator={entityTypeFieldsAndIndicator}
                  expanded={expanded[record.uid]}
                  onExpandCollapse={onExpandCollapse}
                  record={record}
                  showExpander
                />
              </Box>
            ))}
          </Motion>
        </Box>
      </Box>
    );
  }
}
